<st-view-state>
    <div class="st-playbook-view-state-header">
        <st-text-area-overlay
            class="st-playbook-view-state-header__title"
            minHeight="2rem"
            panelClass="st-playbook-view-state-header__title"
            [value]="viewStateTitle$ | ngrxPush"
            [placeholder]="languageSettings.PSTWebAddViewTitleLabel"
            [required]="true"
            (changed)="updateTitle($event)" />
    </div>
    <mat-tab-group class="st-playbook-view-state-tab-group">
        <mat-tab [label]="languageSettings.PSTWebSettingsBar">
            <div class="st-playbook-view-state-tab-settings">
                <div class="st-playbook-view-state-tab-settings-top-tiles">
                    <div class="st-playbook-view-state-tab-settings__type-content">
                        <span class="st-playbook-view-state-tab-settings__type-content__label">Content Type</span>
                        <mat-radio-group
                            class="st-playbook-view-state-tab-settings__type-content-radio-group"
                            [value]="viewStateType$ | ngrxPush"
                            (change)="updateViewStateType($event.value)">
                            <mat-radio-button [value]="viewStateTypes.TOPIC">Topic</mat-radio-button>
                            <mat-radio-button [value]="viewStateTypes.ASSIGNMENT">Assignment</mat-radio-button>
                            <mat-radio-button [value]="viewStateTypes.SCRIPT">Story</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <ng-container *ngIf="(viewStateType$ | ngrxPush) === viewStateTypes.TOPIC">
                    <div
                        *ngrxLet="viewStateLayout$ as viewStateLayout"
                        class="st-playbook-view-state-tab-settings-default-layout">
                        <span class="st-playbook-view-state-tab-settings-default-layout__label"> {{ languageSettings.PSTWebDefLayoutLabel }} </span>
                        <button
                            class="st-playbook-view-state-tab-settings-default-layout__button"
                            mat-stroked-button
                            [matMenuTriggerFor]="layoutMenu">
                            {{ viewStateLayout?.Label }} {{ languageSettings.PSTWebLayoutLabel }}
                        </button>
                        <mat-menu #layoutMenu="matMenu">
                            <mat-selection-list
                                hideSingleSelectionIndicator
                                [multiple]="false"
                                (selectionChange)="updateLayout(viewStateLayout, $event?.options?.[0]?.value)">
                                <mat-list-option
                                    *ngFor="let option of viewStateLayout?.Options"
                                    [value]="option.id">
                                    <div
                                        matListItemTitle
                                        [dir]="isRTL">
                                        {{ option.title }}
                                    </div>
                                </mat-list-option>
                            </mat-selection-list>
                        </mat-menu>
                    </div>
                </ng-container>
                <div
                    *ngrxLet="viewStateGrouping$ as viewStateGrouping"
                    class="st-playbook-view-state-tab-settings-default-grouping">
                    <span class="st-playbook-view-state-tab-settings-default-grouping__label"> {{ languageSettings.PSTWebDefContGroupByCriteriaLabel }}</span>
                    <button
                        class="st-playbook-view-state-tab-settings-default-grouping__button"
                        mat-stroked-button
                        [matMenuTriggerFor]="groupingMenu">
                        {{ viewStateGrouping?.Label }}
                    </button>
                    <mat-menu #groupingMenu="matMenu">
                        <mat-selection-list
                            hideSingleSelectionIndicator
                            [multiple]="false"
                            (selectionChange)="updateGroupBy(viewStateGrouping, $event?.options?.[0]?.value)">
                            <mat-list-option
                                *ngFor="let option of viewStateGrouping?.Options"
                                [value]="option.id"
                                [dir]="isRTL">
                                <div matListItemTitle>{{ option.title }}</div>
                            </mat-list-option>
                        </mat-selection-list>
                    </mat-menu>
                </div>
                <div class="st-playbook-view-state-tab-settings-default-grouping-order">
                    <span class="st-playbook-view-state-tab-settings-default-grouping-order__label"> {{ languageSettings.PSTWebGroupSortOrderLabel }} </span>
                    <button
                        mat-icon-button
                        (click)="toggleGroupSortOrder()">
                        <mat-icon> {{ viewStateGroupByIcon$ | ngrxPush }} </mat-icon>
                    </button>
                </div>
                <div
                    *ngrxLet="viewStateSorting$ as viewStateSorting"
                    class="st-playbook-view-state-tab-settings-default-sorting">
                    <span class="st-playbook-view-state-tab-settings-default-sorting__label"> {{ languageSettings.PSTWebDefContSortByCriteriaLabel }}</span>
                    <button
                        mat-stroked-button
                        class="st-playbook-view-state-tab-settings-default-sorting__button"
                        [matMenuTriggerFor]="sortingMenu">
                        {{ viewStateSorting?.Label }}
                    </button>
                    <mat-menu #sortingMenu="matMenu">
                        <mat-selection-list
                            hideSingleSelectionIndicator
                            [multiple]="false"
                            (selectionChange)="updateSortBy(viewStateSorting, $event?.options?.[0]?.value)">
                            <mat-list-option
                                *ngFor="let option of viewStateSorting?.AllOptions"
                                [value]="option.id"
                                [dir]="isRTL">
                                <div matListItemTitle>{{ option.title }}</div>
                            </mat-list-option>
                        </mat-selection-list>
                    </mat-menu>
                </div>
                <div class="st-playbook-view-state-tab-settings-default-sorting-order">
                    <span class="st-playbook-view-state-tab-settings-default-grouping-order__label">{{ languageSettings.PSTWebContentSortOrder }} </span>
                    <button
                        mat-icon-button
                        (click)="toggleSortOrder()">
                        <mat-icon> {{ viewStateSortByIcon$ | ngrxPush }} </mat-icon>
                    </button>
                </div>
                <div
                    *ngIf="(viewStateType$ | ngrxPush) === viewStateTypes.TOPIC"
                    class="st-playbook-view-state-tab-settings-map">
                    <span class="st-playbook-view-state-tab-settings-map__label">{{ languageSettings.PSTWebMapSettingsBar }} </span>
                    <mat-checkbox
                        [checked]="viewStateMapShowTeamLocations$ | ngrxPush"
                        (change)="updateMapShowTeamLocations($event.checked)">
                        {{ languageSettings.PSTWebShowTeamLocationsLabel }}
                    </mat-checkbox>
                    <mat-checkbox
                        [checked]="viewStateMapZoomToCoverage$ | ngrxPush"
                        (change)="updateMapZoomToCoverage($event.checked)">
                        {{ languageSettings.PSTWebZoomToCoverageLabel }}
                    </mat-checkbox>
                    <mat-checkbox
                        [checked]="viewStateLockMapLocation$ | ngrxPush"
                        (change)="updateLockMapLocation($event.checked)">
                        {{ languageSettings.PSTWebLockMapLocationLabel }}
                    </mat-checkbox>
                </div>
            </div>
        </mat-tab>
        <mat-tab [label]="languageSettings.PSTWebFilterRequiredLabel">
            <div class="st-playbook-view-state-tab-required">
                <div
                    *ngIf="viewStateHasRequiredFilters$ | ngrxPush; else hasNoFilters"
                    class="st-playbook-view-state-tab-required-missing">
                    <div class="st-playbook-view-state-tab-required-filter-buttons">
                        <button
                            mat-stroked-button
                            color="primary"
                            class="st-playbook-view-state-tab-required-filter-buttons__add"
                            [matMenuTriggerFor]="listRequiredFilterDropDownMenu">
                            {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                        </button>
                        <button
                            mat-flat-button
                            class="st-playbook-view-state-tab-required-filter-buttons__clear-all"
                            (click)="onClearAllFilters(true)">
                            {{ languageSettings.PSTWebClearAllLabel }}
                        </button>
                    </div>
                    <st-filter-list
                        [disabled]="false"
                        [filters]="viewStateRequiredFilters$ | ngrxPush"
                        [filterType]="filterTypes.REQUIRED"
                        (update)="onUpdateFilter(true)"
                        (remove)="onRemoveFilter($event, filterTypes.REQUIRED)" />
                </div>
                <ng-template #hasNoFilters>
                    <div class="st-playbook-view-state-tab-required-missing__label">There are no required filters configured currently for this view.</div>
                    <button
                        mat-stroked-button
                        color="primary"
                        class="st-playbook-view-state-tab-required-missing__add"
                        [matMenuTriggerFor]="listRequiredFilterDropDownMenu">
                        {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                    </button>
                </ng-template>
                <mat-menu #listRequiredFilterDropDownMenu="matMenu">
                    <mat-selection-list
                        st-click-stop-propagation
                        [ngModel]="viewStateRequiredFiltersIDs$ | ngrxPush"
                        (selectionChange)="onFilterStateChange($event, true)">
                        @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                            <mat-list-option
                                [disabled]="!item.NotUsed && !item.IsRequired"
                                [dir]="isRTL"
                                [value]="item.ID">
                                {{ item.DefaultCaption }}
                            </mat-list-option>
                        }
                    </mat-selection-list>
                </mat-menu>
            </div>
        </mat-tab>
        <mat-tab [label]="languageSettings.PSTWebOptionalFiltersLabel">
            <div class="st-playbook-view-state-tab-optional">
                <div
                    *ngIf="viewStateHasOptionalFilters$ | ngrxPush; else hasNoOptionalFilters"
                    class="st-playbook-view-state-tab-optional-missing">
                    <div class="st-playbook-view-state-tab-optional-filter-buttons">
                        <button
                            mat-stroked-button
                            color="primary"
                            class="st-playbook-view-state-tab-optional-filter-buttons__add"
                            [matMenuTriggerFor]="listOptionalFilterDropDownMenu">
                            {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                        </button>

                        <button
                            mat-flat-button
                            class="st-playbook-view-state-tab-optional-filter-buttons__clear-all"
                            (click)="onClearAllFilters(false)">
                            {{ languageSettings.PSTWebClearAllLabel }}
                        </button>
                    </div>
                    <st-filter-list
                        [disabled]="false"
                        [filters]="viewStateOptionalFilters$ | ngrxPush"
                        [filterType]="filterTypes.OPTIONAL"
                        (update)="onUpdateFilter(false)"
                        (remove)="onRemoveFilter($event, filterTypes.OPTIONAL)" />
                </div>
                <ng-template #hasNoOptionalFilters>
                    <div class="st-playbook-view-state-tab-optional-missing__label">There are no optional filters configured currently for this view.</div>
                    <button
                        mat-stroked-button
                        color="primary"
                        class="st-playbook-view-state-tab-optional-missing__add"
                        [matMenuTriggerFor]="listOptionalFilterDropDownMenu">
                        {{ '+ ' + languageSettings.PSTWebAddFilterLabel }}
                    </button>
                </ng-template>
                <mat-menu #listOptionalFilterDropDownMenu="matMenu">
                    <mat-selection-list
                        st-click-stop-propagation
                        [ngModel]="viewStateOptionalFiltersIDs$ | ngrxPush"
                        (selectionChange)="onFilterStateChange($event, false)">
                        @for (item of viewStateAllFilters$ | ngrxPush; track item.ID) {
                            <mat-list-option
                                [disabled]="!item.NotUsed && item.IsRequired"
                                [dir]="isRTL"
                                [value]="item.ID">
                                {{ item.DefaultCaption }}
                            </mat-list-option>
                        }
                    </mat-selection-list>
                </mat-menu>
            </div>
        </mat-tab>
    </mat-tab-group>
</st-view-state>
